/** Shared control chrome — matches EstimatorSection rhythm. */
export const tabBase =
  'inline-flex items-center justify-center shrink-0 whitespace-nowrap px-4 sm:px-5 py-2.5 text-[11px] sm:text-xs uppercase tracking-[0.12em] sm:tracking-widest border transition-colors duration-300 min-h-[44px]';
export const tabActive = 'border-foreground bg-foreground text-background';
export const tabIdle =
  'border-border text-muted-foreground hover:border-foreground hover:text-foreground';

export const sectionTitle = 'text-xs uppercase tracking-widest text-muted-foreground mb-4';
